import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { useCallback } from "react";
import { useClient as useUrqlClient } from "urql";
import { useSnapshot } from "valtio";
import { toLowerCase } from "../lib/string";
import { useAddress } from "../polychain/hooks/useAddress";
import { PolychainError } from "../polychain/lib/errors";
import { BlurActions, BlurState, isValidToken } from "../stores/blurStore";
const GetBlurAuthTokenQuery = graphql(`
    query GetBlurAuthToken(
      $address: String!
      $expiresOn: String!
      $hmac: String!
      $message: String!
      $signature: String!
      $chain: ChainIdentifier!
    ) {
      blurAuthToken(
        address: $address
        expiresOn: $expiresOn
        hmac: $hmac
        message: $message
        signature: $signature
        chain: $chain
      ) {
        accessToken
      }
    }
  `, []);
export function useBlurAuthToken() {
  const $ = _c(2);
  const currentAddress = useAddress();
  const {
    tokens
  } = useSnapshot(BlurState);
  const token = currentAddress ? tokens[currentAddress] : null;
  let t0;
  if ($[0] !== token) {
    t0 = token && isValidToken(token) ? token.accessToken : null;
    $[0] = token;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export const useBlurAuth = () => {
  const $ = _c(8);
  const urqlClient = useUrqlClient();
  const currentAddress = useAddress();
  const {
    tokens
  } = useSnapshot(BlurState);
  let t0;
  if ($[0] !== currentAddress || $[1] !== tokens) {
    t0 = currentAddress ? isValidToken(tokens[currentAddress]) : false;
    $[0] = currentAddress;
    $[1] = tokens;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isAuthenticated = t0;
  let t1;
  if ($[3] !== urqlClient) {
    t1 = async args => {
      const {
        data
      } = await urqlClient.query(GetBlurAuthTokenQuery, {
        ...args,
        address: toLowerCase(args.address)
      });
      const accessToken = data?.blurAuthToken.accessToken;
      if (accessToken) {
        BlurActions.setToken(args.address, {
          accessToken,
          expiresOn: args.expiresOn
        });
      } else {
        throw new PolychainError("Blur Auth failed", "BlurAuthError");
      }
    };
    $[3] = urqlClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const blurAuth = t1;
  let t2;
  if ($[5] !== blurAuth || $[6] !== isAuthenticated) {
    t2 = {
      isAuthenticated,
      blurAuth,
      clear: BlurActions.clear
    };
    $[5] = blurAuth;
    $[6] = isAuthenticated;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};